<template>
  <section class="related-products">
    <h2>Gerelateerde producten</h2>
    <div class="products">
      <product-card
        class="product"
        v-for="product in products"
        :key="product.id"
        :value="product"
      >
      </product-card>
    </div>
  </section>
</template>

<script>
import ProductCard from './ProductCard.vue'
import sampleSize from 'lodash-es/sampleSize'

export default {
  components: { ProductCard },
  props: ['relatedProducts', 'currentProduct'],
  computed: {
    products() {
      let products = this.relatedProducts.filter((product) => {
        return product.id != this.currentProduct
      })

      products = sampleSize(products, 5)
      return products
    }
  }
}
</script>

<style lang="scss" scoped>
.related-products {
  padding: 40px 0;
  width: 100%;
}
h2 {
  font-size: 19px;
  color: var(--sub-color);
  font-weight: 500;
  padding-bottom: 7px;
}

.product {
  margin: 13px 9px;

  /*   &:nth-child(5) {
    display: none;
  } */
}

.products {
  margin-left: -10px;
  display: flex;
  flex-direction: row;
  //justify-content: center;
  flex-wrap: wrap;
  width: calc(100% + 20px);
}

.mobile {
  .products {
    margin-left: -20px;
    width: calc(100% + 40px);
  }
  .product-card {
    margin: 5px;
    max-width: 47%;
  }
}

@media only screen and (min-width: 1340px) {
  .product:nth-child(5) {
    display: none;
  }
}
@media only screen and (min-width: 1551px) {
  .product:nth-child(5) {
    display: block;
  }
}
</style>
